import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class PostPackageGroupService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    getDatatable({skip, limit, sort, desc, region, area, start, end, postIndex}) {
        return Vue.axios.get(`${APIHOST}/api/PostPackageGroupDataTable`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                limit: limit,
                skip: skip,
                sort: sort,
                desc: desc,
                region: region ? region.id : null,
                area: area ? area.id : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
                postIndex: postIndex ? postIndex : null
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    get(uid) {
        return Vue.axios.get(`${APIHOST}/api/PostPackageGroup`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getPostPackages(uid) {
        return Vue.axios.get(`${APIHOST}/api/PostPackageGroupPackage`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getPdfPath(postPackageGroup) {
        return `${APIHOST}/api/PostPackageGroupPdf/${postPackageGroup.uid}`
    }

    getPdf(postPackage) {
        return Vue.axios.get(`${APIHOST}/api/PostPackageGroupPdf`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: postPackage.uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    create(postCode) {
        return Vue.axios.post(`${APIHOST}/api/PostPackageGroup`, {
            PostCode: postCode,
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }
}

export default new PostPackageGroupService()